import { useAppSelector } from '@/hooks'
import DownloadAction from '@/modules/device-module/components/header/DownloadAction'
import FavoritesMenu from '@/modules/device-module/components/header/FavoritesMenu'
// import { useGetDeviceDetailQuery }       from '@/modules/device-module/services/deviceService'
import { stateDeviceSelector } from '@/modules/device-module/store/stateSlice'
// import { useGetUserProfileQuery }            from '@/modules/user-aqua/services/userService'
import PrintButton from '@/components/Organisms/PrintButton/PrintButton'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetDeviceDetailQuery } from '@/modules/device-module/services/deviceService'
import { DeviceType } from '@/types/enums'
import Favorites from '@/components/Organisms/Favorites/Favorites'

const ActionMenu = () => {
  // const { data: currentUserData } = useGetUserProfileQuery('0')
  // const currentUserType = currentUserData?.data.typeId

  const { id } = useParams()

  const { data } = useGetDeviceDetailQuery(Number(id))
  const isMeteoStation = data?.typeId === DeviceType.meteo
  const isDit = data?.typeId === DeviceType.dit
  const { fromDate, toDate } = useAppSelector(stateDeviceSelector)

  const isDownloadDisabled = isMeteoStation || isDit
  const isPrintDisabled = isMeteoStation || isDit

  const favoriteIds = data?.favoriteCategoryIds || []
  return (
    <Box
      display='flex'
      alignItems='flex-start'
    >
      <Favorites favoriteIds={favoriteIds} />
      <DownloadAction disableDownload={isDownloadDisabled} />
      <PrintButton
        deviceId={Number(id)}
        fromDate={fromDate}
        toDate={toDate}
        reportPath='reports/reportIndividual'
        disabled={isPrintDisabled}
      />
    </Box>
  )
}

export default ActionMenu
